module.exports = __webpack_public_path__ + "img/black_drop.6b322220.svg";